import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingComponent } from './billing/billing.component';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {RouterModule, Routes} from '@angular/router';

import { ViewoutpatientComponent } from './viewoutpatient/viewoutpatient.component';
import { ViewoutpatientbillComponent } from './viewoutpatientbills/viewoutpatientbill.component';
import { EnquiryComponent } from './enquiry/enquiry.component';

import { BillingService } from '../billing-module/billing.service';
import { ViewinpatientModule } from '../viewinpatient-module/viewinpatient.module';

import { SharedModule } from '../shared/shared.module';
import { VaccinationComponent } from './vaccination/vaccination.component';

const billingRoutes: Routes = [
  { path: 'OutPatient', component: ViewoutpatientComponent },
  { path: 'Enquiry', component: EnquiryComponent },
  { path: 'Vaccination', component: VaccinationComponent}
];

@NgModule({
  declarations: [
    BillingComponent,
    ViewoutpatientComponent,
    ViewoutpatientbillComponent,
    EnquiryComponent,
    VaccinationComponent
  ],
  exports: [
    RouterModule,
    ViewoutpatientComponent,
    ViewoutpatientbillComponent,
    EnquiryComponent,
    VaccinationComponent
  ],
  imports: [
    ViewinpatientModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule.forChild(billingRoutes),
    SharedModule
  ]
})
export class BillingModuleModule { }
